module.exports = __webpack_public_path__ + "static/thirty-minute-walk-02a5091d12fb7a89195518d5bf70e4ff.svg";